import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { Mail } from "./Mail";
import { Button } from "primereact/button";
import { GenerateInvoices, IInvoiceTracking } from "./GenerateInvoices";
import { Fetch, ILazyParams, baseUrl } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Table } from "../showTimesheet/Table";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IPurchaseOrder, POStatus } from "../../models/PurchaseOrder";
import { Panel } from "primereact/panel";
// import { Checkbox } from "primereact/checkbox";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { BillingCycle } from "../showPurchaseOrder/GeneratePO";
import { PaymentTerm } from "../../models/ConsultantMast";
import { BillingCycleMap, PaymentTermMap } from "../../models/FDropdown";
export interface InvoiceTracking {
    addedBy?: string,
    client?: string,
    consultant_ID?: number,
    consultant_Name?: string,
    dueDate?: string,
    end_Client?: string,
    fromDate?: string,
    invoiceAmount?: number,
    invoiceHours?: number,
    invoiceNo?: string,
    invoicePath?: string,
    invoice_ID?: number,
    job_Titles?: string,
    mRate?: number,
    pO_ID?: number,
    prime_Vendor_Billing_Cycle?: BillingCycle,
    prime_Vendor_Payment_Term?: PaymentTerm,
    sRate?: number,
    sales?: string,
    start_Date?: string,
    timeSheet_Status1?: string,
    toDate?: string,
    vendor?: string,
    verifiedBy?: string,
    invoiceStatus?: string,
    createdOn?: string,
    verifyComment?: string,
    paymentStatus?: string,
    balance_Rate?: number,
    is_Verfied?: boolean,
    receivedAmount?: number,
    invoiceDate?: any,
    is_Verified?: boolean,
    invoiceNO?: string,
    created_Type?: string,
};

const EmptyInvioceGeneration: IInvoiceTracking = {
    invoice_ID: null,
    invoiceNO: null,
    pO_ID: null,
    consultant_ID: null,
    fromDate: null,
    toDate: null,
    invoiceHours: null,
    invoiceAmount: null,
    invoiceDate: null,
    dueDate: null,
    preparedBy: null,
    verfiedBy: null,
    verifyComment: null,
    invoiceStatus: null,
    paymentStatus: null,
    invoice_Cycle: null,
    payment_Term: null,
    invoicePath: null,
    createdOn: null,
    createdBy: null,
    updatedOn: null,
    updatedBy: null,
};

interface IProps {
    permissions: IPermissionProps,
    toast: any,
    po: IPurchaseOrder,
}

export const EmptyFilter: InvoiceTrackingFilter = {
    year: null,
    month: null,
    company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    paymentStatus: null
}

export const InvoiceTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: InvoiceTracking[], loading: boolean });
    const [emailBox, setEmailBox] = useState(false);
    const [generateInvoices, setGenerateInvoices] = useState({ singleData: {}, open: false, action: false, recent: {} } as { singleData: IInvoiceTracking, open: boolean, action: boolean, recent: InvoiceTracking });
    const [modal, setModal] = useState({ singleData: {}, open: false } as any);
    const [timsheetModal, setTimsheetModal] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });
    const [reload, setReload] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [consultantAllInvoices, setConsultantAllInvoices] = useState({ singleData: 0, open: false } as { singleData: number, open: boolean });
    const [invoiceLeft, setInvoiceLeft] = useState<number>(0);
    const dt = useRef<any>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                {(consultantAllInvoices.open === true && consultantAllInvoices.singleData !== 0) && <Button label="Go Back" icon="pi pi-arrow-left" className="p-button-info" onClick={() => setConsultantAllInvoices({ singleData: 0, open: false })} />}
            </React.Fragment>
        );
    };
    const leftToolbarTemplate2 = () => {
        let newdata = {
            pO_ID: props.po.pO_ID,
            consultant_ID: props.po.consultant_ID,
            invoiceRate: props.po.sRate,
            invoice_Cycle: props.po.prime_Vendor_Billing_Cycle,
            payment_Term: props.po.prime_Vendor_Payment_Term
        };
        return (
            <React.Fragment>
                {props.permissions.is_Create && props.po.pO_ID && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 w-6rem" onClick={() => {
                    // if ((new Date() <= new Date(props.po.project_End_Date || "")) && (props.po.pO_Status === "Joined" || props.po.pO_Status === "Ended") && props.po.prime_Vendor_Billing_Cycle) {
                    //     setGenerateInvoices({ singleData: newdata, open: true, action: false, recent: tableData.tableData[tableData.tableData.length - 1] });
                    // }
                    // else if ((new Date() > new Date(props.po.project_End_Date || ""))) {
                    //     props.toast.current.show({ severity: 'error', detail: "Project Ended", life: 3000 });
                    // } 
                    // else if (props.po.pO_Status !== "Joined") {
                    //     props.toast.current.show({ severity: 'error', detail: `Consultant PO Status ${props.po.pO_Status}`, life: 3000 });
                    // }
                    if ((props.po.pO_Status === POStatus.Joined || props.po.pO_Status === POStatus.Ended) && props.po.prime_Vendor_Billing_Cycle) {
                        setGenerateInvoices({ singleData: newdata, open: true, action: false, recent: tableData.tableData[tableData.tableData.length - 1] });
                    }
                    else if (!props.po.prime_Vendor_Billing_Cycle) {
                        props.toast.current.show({ severity: 'error', detail: `Please add Prime Vendor Billing Cycle`, life: 3000 });
                    };
                    //setGenerateInvoices({ singleData: newdata, open: true, action: false, recent: tableData.tableData[0] });
                }} />}
            </React.Fragment>
        );
        // let newdata = {
        //     pO_ID: props.po.pO_ID,
        //     consultant_ID: props.po.consultant_ID,
        //     invoiceRate: props.po.sRate,
        //     invoice_Cycle: props.po.prime_Vendor_Billing_Cycle,
        //     payment_Term: props.po.prime_Vendor_Payment_Term
        // };
        // return (
        //     <React.Fragment>
        //         {props.permissions.is_Create && props.po.pO_ID && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 w-6rem" onClick={() => setGenerateInvoices({ singleData: newdata, open: true, action: false })} />}
        //     </React.Fragment>
        // );
    };
    const rightToolbarTemplate2 = () => {
        return (
            <React.Fragment>
                <div className="flex w-full ml-5">
                    {/* {(_roles.includes(20) || _roles.includes(1) || (_roles.includes(30) || _roles.includes(31))) && <div className="flex w-25rem">{invoiceLeft !== 0 && <h1 className="flex text-4xl font-bold mr-5">Pending Invoices : <span style={{ color: 'red' }}>{invoiceLeft}</span></h1>}</div>} */}
                    <div className="flex w-25rem">{invoiceLeft !== 0 && <h1 className="flex text-4xl font-bold mr-5">Pending Invoices : <span style={{ color: 'red' }}>{invoiceLeft}</span></h1>}</div>
                </div>
            </React.Fragment>
        );
    };
    const DateFromat = loginObj.date_Format;

    const header = () => {
        return (
            props.po.pO_ID && <React.Fragment>
                <div className="flex">
                    <Panel header="Consultant Name" className="w-3">
                        <p className="m-0">{props.po.consultant_Name}</p>
                    </Panel>
                    {/* <Panel header="PO Start Date" className="w-3">
                        <p className="m-0">{props?.po?.project_Start_Date1}</p>
                    </Panel> */}
                    <Panel header="PO Start Date" className="w-3">
                        <p className="m-0">{safeFormatDate(props?.po?.project_Start_Date1, "dd/MM/yyyy", DateFromat)}
                        </p>
                    </Panel>
                    {/* <Panel header="PO End Date" className="w-3">
                        <p className="m-0">{props?.po?.project_End_Date1}</p>
                    </Panel> */}
                    <Panel header="PO End Date" className="w-3">
                        <p className="m-0">{safeFormatDate(props?.po?.project_End_Date1, "dd/MM/yyyy", DateFromat)} </p>
                    </Panel>
                    <Panel header="Sales Manager" className="w-3">
                        <p className="m-0">{props.po.salesmanager?.split("-")[0]}</p>
                    </Panel>
                    <Panel header="Margin" className="w-3">
                        <p className="m-0">{props.po.mRate}</p>
                    </Panel>
                    <Panel header="B. Cycle" className="w-3">
                        <p className="m-0">{props.po.prime_Vendor_Billing_Cycle ? BillingCycleMap[props.po.prime_Vendor_Billing_Cycle] : ''}</p>
                    </Panel>
                    <Panel header="P. Term" className="w-3">
                        <p className="m-0">{props.po.prime_Vendor_Payment_Term ? PaymentTermMap[props.po.prime_Vendor_Payment_Term] : ''}</p>
                    </Panel>
                </div>
            </React.Fragment>
        );
    }
    const consultant_Name = (rowData: InvoiceTracking) => {
        const currentDate = new Date();
        return (
            <>
                <span
                //className="cursor-pointer text-cyan-700 underline" 
                //onClick={() => { setTimsheetModal({ singleData: rowData, open: true });
                // if (rowData.consultant_ID) setConsultantAllInvoices({ singleData: rowData.consultant_ID || 0, open: true }); }}
                >{rowData?.consultant_Name}</span>
            </>
        );
    };
    const emailInv = (rowData: InvoiceTracking) => {
        return <span className="text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => setEmailBox(true)}>Send Email</span>
    };
    const action = (rowData: InvoiceTracking) => {
        let data = {
            invoice_ID: rowData.invoice_ID,
            invoiceNO: rowData.invoiceNo,
            pO_ID: rowData.pO_ID,
            consultant_ID: rowData.consultant_ID,
            fromDate: new Date(rowData.fromDate || ""),
            toDate: new Date(rowData.toDate || ""),
            invoiceHours: rowData.invoiceHours,
            invoiceAmount: rowData.invoiceAmount,
            dueDate: rowData.dueDate ? new Date(rowData.dueDate || "") : null,
            invoiceStatus: rowData.invoiceStatus,
            invoiceRate: rowData.sRate,
            invoice_Cycle: rowData.prime_Vendor_Billing_Cycle,
            payment_Term: rowData.prime_Vendor_Payment_Term,
            paymentStatus: rowData.paymentStatus,
            balance_Rate: rowData.balance_Rate,
            invoicePath: rowData.invoicePath,
            invoiceDate: rowData.invoiceDate ? new Date(rowData.invoiceDate || "") : null,
            verifyComment: rowData.verifyComment,
            verifiedBy: rowData.verifiedBy,
            is_Verfied: rowData.is_Verfied
        };
        //data.invoiceDate = new Date(rowData.toDate || "");
        //data.preparedBy = rowData.addedBy ;
        //data.verfiedBy = rowData.addedBy ;
        //data.verifyComment = rowData.addedBy ;
        //data.paymentStatus = rowData.addedBy;
        return rowData.invoice_ID && <React.Fragment>
            <Button className={(rowData.is_Verified && rowData.is_Verified !== null && rowData.is_Verified === true) ? "pi pi-pencil text-primary bg-green-300 border-none text-base" : "pi pi-pencil text-primary bg-pink-100 border-none text-base"} tooltip="Edit" onClick={() => setGenerateInvoices({ singleData: { ...data, is_Verfied: data.is_Verfied, verify: (rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? true : false }, open: true, action: false, recent: {} })}></Button>
            {/* <span className="text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => setGenerateInvoices({ singleData: data, open: true, action: true })}>Verify Inv</span> */}
            {/* <Button className={(rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? "pi pi-check-square text-primary bg-green-300 border-none text-lg" : "pi pi-check-square text-primary bg-pink-100 border-none text-base"} tooltip="Verify Invoice" onClick={() => setGenerateInvoices({ singleData: data, open: true, action: true })}></Button> */}
        </React.Fragment>;
        // if (data.invoiceNO !== null && data.invoiceNO !== undefined) {
        // } else {
        //     return <></>;
        // };
    };
    const status = (rowData: InvoiceTracking) => {
        let newdata = {
            pO_ID: rowData.pO_ID,
            consultant_ID: rowData.consultant_ID,
            invoiceRate: rowData.sRate,
            invoice_Cycle: rowData.prime_Vendor_Billing_Cycle,
            payment_Term: rowData.prime_Vendor_Payment_Term
        };
        // data.invoice_ID = rowData.invoice_ID;
        // data.invoiceNO = rowData.invoiceNo;
        // data.fromDate = new Date(rowData.fromDate || "");
        // data.toDate = new Date(rowData.toDate || "");
        // data.invoiceHours = rowData.invoiceHours;
        // data.invoiceAmount = rowData.invoiceAmount;
        //data.invoiceDate = new Date(rowData.toDate || "");
        // data.dueDate = new Date(rowData.dueDate || "");
        //data.preparedBy = rowData.addedBy ;
        //data.verfiedBy = rowData.addedBy ;
        //data.verifyComment = rowData.addedBy ;
        // data.invoiceStatus = rowData.invoiceStatus;
        //data.paymentStatus = rowData.addedBy;
        // data.invoicePath = rowData.invoicePath;
        // data.invoiceDate = new Date(rowData.createdOn || "");

        if (props.po.pO_ID) {
            return <span className={props.po.pO_ID ? "" : "cursor-pointer text-cyan-700 underline"} style={{ cursor: "pointer", color: (rowData.is_Verified && rowData.is_Verified !== null && rowData.is_Verified === true) ? "black" : "red" }} onClick={() => {
                // if (!props.po.pO_ID) { setGenerateInvoices({ singleData: newdata, open: true, action: false }); };
            }}>{(rowData.is_Verified && rowData.is_Verified !== null && rowData.is_Verified === true) ? "Verified" : (rowData.is_Verified === false ? "Rejected" : "Pending")}</span>;
        } else if (!props.po.pO_ID) {
            return <span className={props.po.pO_ID ? "" : "cursor-pointer text-cyan-700 underline"} style={{ cursor: "pointer", color: rowData.timeSheet_Status1 === "Pending" ? "red" : "black" }} onClick={() => {
                if (!props.po.pO_ID) { setGenerateInvoices({ singleData: newdata, open: true, action: false, recent: {} }); };
            }}>{rowData.timeSheet_Status1}</span>;
        }
    };
    const hideDialog = () => {
        setEmailBox(false);
        setGenerateInvoices({ singleData: {}, open: false, action: false, recent: {} });
        setTimsheetModal({ singleData: {}, open: false });
    }
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.company = invoiceFilter.company?.vendor_Company_ID;

        let po_id_Query = "";
        if (props.po.pO_ID) {
            po_id_Query = `&PO_ID=${props.po.pO_ID}`;
        }

        const response = await Fetch("InvoiceTracking/getList", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setTableData({ tableData: data, loading: false });
            GetTimesheetLeft();
            //setTotalRecords(2614);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }
    const loadTableDataCount = async () => {
        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.company = invoiceFilter.company?.vendor_Company_ID;

        let po_id_Query = "";
        if (props.po.pO_ID) {
            po_id_Query = `&PO_ID=${props.po.pO_ID}`;
        }

        const response = await Fetch("InvoiceTracking/count", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    };
    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const newInv = (rowData: InvoiceTracking) => {
        let newdata = {
            pO_ID: rowData.pO_ID,
            consultant_ID: rowData.consultant_ID,
            invoiceRate: rowData.sRate,
            invoice_Cycle: rowData.prime_Vendor_Billing_Cycle,
            payment_Term: rowData.prime_Vendor_Payment_Term
        };
        return (<Button icon="pi pi-plus" className="p-button-success p-button-rounded p-button-text text-blue-400" onClick={() => setGenerateInvoices({ singleData: newdata, open: true, action: false, recent: tableData.tableData[0] })} />);
    };

    const rowClass = (data: any) => {
        return {
            'bg-green-300 text-black': (data.is_Verified !== null && data.is_Verified === true),
            //'bg-yellow-100 text-black': data.verifiedBy === null,
            'bg-pink-100 text-black': data.is_Verified === null || data.is_Verified === false,
        };
    };

    const downLoadInvoice = async (rowData: InvoiceTracking) => {
        if (rowData.created_Type === "System") {
            const params = {
                method: "GET",
                headers: {
                    'Content-Type': 'application/pdf',
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                }
            };
            try {
                const response = await fetch(`${`${baseUrl.split("/api/")[0]}/invoice/download/`}${rowData.invoice_ID}`, params);
                if (response.status === 200) {
                    const blob = await response.blob();
                    const href = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.download = `${rowData?.invoice_ID}.pdf`;
                    a.href = href;
                    a.click();
                    a.href = '';
                } else if (response.status === 400) {
                    const message = await response.text();
                    props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
                }
            } catch {
                props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
            }
        } else {
            const params = {
                method: "GET",
                headers: {
                    'Content-Type': 'application/pdf',
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                }
            };
            try {
                const response = await fetch(`${baseUrl}${"InvoiceTracking/download"}?path=${rowData.invoicePath}`, params);
                if (response.status === 200) {
                    const blob = await response.blob();
                    const href = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.download = `${rowData?.invoiceNo}.pdf`;
                    a.href = href;
                    a.click();
                    a.href = '';
                } else if (response.status === 400) {
                    const message = await response.text();
                    props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
                }
            } catch {
                props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
            }
        }
    };

    // const GetInvoice = async (rowData: InvoiceTracking) => {
    //     const params = {
    //         method: "GET",
    //         headers: {
    //             'Content-Type': 'application/pdf',
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         }
    //     };

    //     try {
    //         console.log(`Requesting invoice for: ${rowData.invoiceNo}`);
    //         const response = await fetch(`${baseUrl}InvoiceTracking/getinvoices?invoiceNo=${rowData.invoiceNo}`, params);

    //         if (response.status === 200) {
    //             const blob = await response.blob();
    //             const href = window.URL.createObjectURL(blob);
    //             const a = document.createElement("a");
    //             a.download = `${rowData?.invoiceNo}.pdf`;
    //             a.href = href;
    //             a.click();
    //             window.URL.revokeObjectURL(href); // Free memory
    //             console.log(`Invoice downloaded: ${rowData.invoiceNo}`);
    //         } else if (response.status === 400) {
    //             const message = await response.text();
    //             props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
    //             console.error(`Error: ${message}`);
    //         } else {
    //             const message = await response.text();
    //             console.error(`Unexpected error: ${response.status} - ${message}`);
    //         }
    //     } catch (error) {
    //         console.error('Fetch error:', error);
    //         props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
    //     }
    // };

    const GetTimesheetLeft = async () => {
        const response = await Fetch("vwPODetails/getTimesheetOrInvoiceLeft", "GET", null, `PO_ID=${props?.po?.pO_ID}&dataType=2`, props.toast);
        if (response) {
            const data = await response.json();
            setInvoiceLeft(data.invoiceLeft);
        }
    };

    const updateVerifyStatus = async (rowData: InvoiceTracking) => {
        if (!(_roles.includes(1) || _roles.includes(26)) && rowData?.paymentStatus !== undefined && rowData?.paymentStatus !== null && (rowData?.paymentStatus?.trim() === 'Paid' || rowData?.paymentStatus?.trim() === 'Over Payment')) {
            props.toast.current.show({ severity: 'error', detail: "Paid Payment Status can not be updated", life: 3000 });
        } else if (rowData.invoice_ID === undefined || rowData.invoice_ID === null || rowData.invoice_ID === 0) {
            props.toast.current.show({ severity: 'error', detail: 'Invoice Not Uploaded Yet', life: 3000 });
        } else {
            const response = await Fetch("vwPODetails/updateInvoiceVerifyStatus", "PUT", null, `invoice_ID=${rowData.invoice_ID}`, props.toast);
            if (response) {
                loadTableData();
            }
        }
    }

    const verifyAction = (rowData: InvoiceTracking) => {
        return <p className="cursor-pointer text-cyan-700 underline" onClick={() => updateVerifyStatus(rowData)}>{rowData.is_Verified === true ? "Reject" : "Verify"}</p>
    };

    useEffect(() => {
        //setConsultantAllInvoices({ singleData: 0, open: false });
        loadTableData();
        loadTableDataCount();
        // GetTimesheetLeft();
    }, [lazyParams, invoiceFilter, consultantAllInvoices]);

    return (
        <>
            {props.po.pO_ID && <Toolbar className="mb-1 py-0" left={leftToolbarTemplate2} right={rightToolbarTemplate2} ></Toolbar>}
            {!props.po.pO_ID && <><Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
                <Accordion>
                    <AccordionTab header="Filter">
                        <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={props.po.pO_ID ? true : false} />
                    </AccordionTab>
                </Accordion></>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                rowClassName={rowClass}
                scrollable
                scrollHeight="100vh"
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                {!props.po.pO_ID && <Column body={newInv} />}
                <Column field="consultant_Name" header="Name" body={consultant_Name} />
                <Column field="invoiceNo" header="Invoice#" />
                {/* <Column field="fromDate" header="From Date" body={(rowData: InvoiceTracking) => {
                    let string = new Date(rowData?.fromDate || "")?.toLocaleDateString("en-in");
                    return <p>{string === "Invalid Date" ? null : string}</p>
                }} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "MM-dd-yyyy", DateFromat)} />
                {/* <Column field="toDate" header="To Date" body={(rowData: InvoiceTracking) => {
                    let string = new Date(rowData?.toDate || "")?.toLocaleDateString("en-in");
                    return <p>{string === "Invalid Date" ? null : string}</p>
                }} /> */}
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "MM-dd-yyyy", DateFromat)} />
                <Column field="invoiceHours" header="Hours" />
                <Column field="sRate" header="S Rate" />
                <Column field="invoiceAmount" header="Amount" />
                {/* <Column field="dueDate" header="Due Date" body={(rowData: InvoiceTracking) => {
                    let string = new Date(rowData?.dueDate || "")?.toLocaleDateString("en-in");
                    return <p>{string === "Invalid Date" ? null : string}</p>
                }} /> */}
                <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, "MM-dd-yyyy", DateFromat)} />
                <Column field="paymentStatus" header="Payment Status" />
                <Column field="timeSheet_Status1" header="Verify Status" body={status} />
                <Column field="" header="Download" body={(rowData) => <span className="cursor-pointer text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => downLoadInvoice(rowData)}>download</span>} />

                <Column field="email_Inv" header="Email Inv" body={emailInv} />
                <Column header="Action" body={action} />
                <Column header="Verify Action" body={verifyAction} />
            </DataTable>
            <Mail open={emailBox} hideDialog={hideDialog} toast={props.toast} />
            <GenerateInvoices open={generateInvoices.open} toast={props.toast} hideDialog={hideDialog} singleData={generateInvoices.singleData} action={generateInvoices.action} loadTableData={loadTableData} loadTableDataCount={loadTableDataCount} po={props.po} recent={generateInvoices.recent} />
            <Dialog visible={timsheetModal.open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={hideDialog} draggable={false}>
                <Table permissions={props.permissions} setModal={setModal} toast={props.toast} reload={reload} setReload={setReload} byConsultant={timsheetModal?.singleData.consultant_ID ? timsheetModal?.singleData.consultant_ID : 0} po={props.po} ></Table>
            </Dialog>
        </>
    );
}